/*    
<summary>
   This file is used to provide initial values or state to the Fota Module observables.
   Developer: Aashish Singh, Created Date: 04-July-2025
</summary>
*/

import { IFotaDevicesStatusListVm } from "../../models/response/IFotaSchedulerDevicesResponse";

export const getInitialFotaSchedulerDeviceStatusState: IFotaDevicesStatusListVm= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    DevicesFotaStatusHistory: []
}